/**
 * Device billing category slice pieces — the categories device pricing rows
 * are grouped under, plus the autocomplete options built from them.
 *
 * Populated indirectly (no dedicated load case); read by pricing forms.
 *
 * Contains:
 * - deviceCategoriesInitialState — adapter state + table view substate
 * - device billing category selectors + autocomplete options
 */
import { createSelector } from '@reduxjs/toolkit';

import { deviceCategoriesAdapter } from '@sophocles/features/billing/slices/adapters';

export const deviceCategoriesInitialState = deviceCategoriesAdapter.getInitialState({
  view: {
    search: null,
    page: 0,
    order: 'asc',
    orderBy: 'id',
  },
});

export const selectDeviceBillingCategoryEntities = state => {
  return state.billing.deviceCategories;
};

export const selectAllDeviceBillingCategories = createSelector(selectDeviceBillingCategoryEntities, state => {
  return Object.keys(state.entities).map(key => state.entities[key]);
});

export const selectDeviceBillingCategoryAutocompleteOptions = createSelector(
  selectAllDeviceBillingCategories,
  categories => {
    return categories.map(category => ({
      label: category.name,
      value: category.id,
    }));
  },
);

const { selectById: selectDeviceBillingCategoryById } = deviceCategoriesAdapter.getSelectors(
  selectDeviceBillingCategoryEntities,
);
export const selectDeviceBillingCategory = id => state => selectDeviceBillingCategoryById(state, id);
export const selectDeviceBillingCategoryViewProperties = createSelector(
  selectDeviceBillingCategoryEntities,
  state => state.view,
);
